import { useState } from 'react';
import { Button } from '../ui/button';
import { Textarea } from '../ui/textarea';
import { toast } from 'sonner';
import { meetingsAPI } from '../../lib/api';
import { fmtDateTimeInTz, apiErrorText } from './meetingsUtils';

export default function MeetingNotesSection({ meetingId, notes, onChanged }) {
  const [text, setText] = useState('');
  const [saving, setSaving] = useState(false);

  const addNote = async () => {
    if (!text.trim()) { toast.error('Please write a note'); return; }
    setSaving(true);
    try {
      await meetingsAPI.addNote(meetingId, text.trim());
      setText('');
      onChanged();
    } catch (e) { toast.error(apiErrorText(e, 'Failed to add note')); }
    finally { setSaving(false); }
  };

  return (
    <div className="space-y-2" data-testid="meeting-notes-section">
      <p className="text-sm font-semibold">Notes</p>
      <div className="space-y-2">
        {(notes || []).length === 0 && <p className="text-xs text-muted-foreground" data-testid="no-notes-msg">No notes yet.</p>}
        {(notes || []).map((n, i) => (
          <div key={i} className="text-sm border-l-2 pl-2" data-testid={`note-row-${i}`}>
            <p>{n.text}</p>
            <p className="text-xs text-muted-foreground">{n.by_name} · {fmtDateTimeInTz(n.at, 'UTC')}</p>
          </div>
        ))}
      </div>
      <div className="flex items-start gap-2">
        <Textarea value={text} onChange={(e) => setText(e.target.value)} placeholder="Add a note..." className="h-16" data-testid="note-input" />
        <Button size="sm" disabled={saving} onClick={addNote} data-testid="note-add-btn">Add</Button>
      </div>
    </div>
  );
}
